<template>
  <SectionSidebar :sections="sections" :variant="variant" />
</template>

<script setup lang="ts">
defineProps<{
  variant: "rail" | "full";
}>();

const sections = useGestionSections();
</script>
